<div class="wetter_content_container">
  <section class="bericht-text-container">
    <h3 class="bericht-text-sub-label">Kommende Stunden</h3>
    <p>{{wetterblitzSchlagzeile?.kommende_Stunden?.kurzbeschreibung}}</p>
    <p>{{wetterblitzSchlagzeile?.kommende_Stunden?.beschreibung}}</p>
  </section>
  <section class="bericht-text-container">
    <h3 class="bericht-text-sub-label">Kommende Nacht bis zum nächsten Morgen</h3>
    <p>{{wetterblitzSchlagzeile?.kommende_Nacht_bis_naechsten_Morgen?.kurzbeschreibung}}</p>
    <p>{{wetterblitzSchlagzeile?.kommende_Nacht_bis_naechsten_Morgen?.beschreibung}}</p>
  </section>
</div>
